/* Spanish catalog mirroring locale-autopilot-followup-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'ap.skip.title': 'Omitir seguimiento',
  'ap.skip.nextMonth': 'Recordármelo el mes que viene',
  'ap.skip.always': 'Ignorar esta partida',
  'ap.skip.help': 'Aplaza la partida hasta el mes que viene, o ignora exactamente esta partida. Las nuevas facturas, clientes y otros hallazgos seguirán apareciendo.',
  'ap.skip.itemFallback': 'Esta partida de seguimiento',
  'ap.skip.all': 'Omitir todas',
  'ap.skip.allInvoices': 'Todos los documentos de esta lista',
  'ap.skip.allCustomers': 'Todos los clientes de esta lista',
  'ap.agent.followup.title': 'Agente de seguimiento',
  'ap.agent.followup.detail': 'Detecta información y discrepancias que no pertenecen a un agente de presentación.',
  'ap.permission.followup.label': 'Agente de seguimiento',
  'ap.permission.followup.desc': 'Detecta información, conversaciones con clientes y discrepancias que no pertenecen a un agente de presentación.',
  'ap.lineIgnoredToast': 'Esta partida se ha ignorado. Las nuevas partidas de seguimiento seguirán apareciendo.',
  'ap.linesSkippedToast': 'Se omitieron {{count}} partidas.',
  'ap.followup.correctionOne': 'Hay que corregir {{count}} error.',
  'ap.followup.correctionMany': 'Hay que corregir {{count}} errores.',
  'ap.followup.correctionDetailOne': 'Hay que corregir {{count}} partida',
  'ap.followup.correctionDetailMany': 'Hay que corregir {{count}} partidas',
  'ap.followup.mustCorrect': 'Hay que corregir',
  'ap.followup.correct': 'Corregir',
  'ap.followup.correctInSettings': 'Corregir en ajustes',
});
